import {Grid, GridCellProps, GridNoRecords, GridToolbar} from "@progress/kendo-react-grid";
import {GridColumn as Column} from "@progress/kendo-react-grid/dist/npm/GridColumn";
import {CustomButton} from "ndr-designsystem";
import {DeleteOutline} from "@mui/icons-material";
import React, {ReactElement, useEffect, useState} from "react";
import {SubmitHandler, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {useTranslation} from "react-i18next";
import * as yup from 'yup';
import {AddTenantUser, DeleteTenantUser, fetchTenantByID} from "../store/Thunks";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import AddDialog from "../../../Components/AddDialog/AddDialog";
import {fetchUsers} from "../../Admins/store/Thunks";

const Users = (): ReactElement => {
    const dispatch = useAppDispatch();
    const { currentTenant: tenant } = useAppSelector(state => state.Tenants)
    const { users } = useAppSelector(state => state.Admins)
    const { t } = useTranslation(['tabels', 'common']);
    const [dialogOpen, setDialogOpen] = useState(false);

    const validationSchema = yup.object().shape({
        userId: yup.string().required()
    });

    const { control, reset, formState, handleSubmit: HandleUsersDialogSubmit } = useForm<any>({
        mode: 'onTouched',
        resolver: yupResolver(validationSchema)
    });

    useEffect(() => {
        dispatch(fetchUsers())
    }, [dispatch])

    useEffect(() => {
        if (formState.isSubmitSuccessful) {
            reset();
        }
    }, [formState, reset])

    const onCurrentUserClose = (): void => {
        setDialogOpen(false)
        reset()
    }

    const onUsersDialogSubmit: SubmitHandler<any> = async (data) => {
        await dispatch(AddTenantUser({ userId: data.userId, tenantId: tenant?.inventoryItemId, tenantRevision: tenant?.revision }));
        setDialogOpen(false);
        reset();
    }

    const handleRemove = async (index: number): Promise<void> => {
        await dispatch(DeleteTenantUser((tenant?.users ?? [])[index]))
        if (tenant?.inventoryItemId) {
            dispatch(fetchTenantByID(tenant.inventoryItemId))
        }
    }

    const commandCell = ({ dataIndex }: GridCellProps): any => (
        <td>
            <button
                type="button"
                className="k-button k-grid-command"
                onClick={() => handleRemove(dataIndex)}
            >
                <DeleteOutline color="primary" />
            </button>
        </td>
    )

    return <>
        <Grid data={tenant?.users} className="no-scrollbar" dataItemKey="inventoryItemId">
            {tenant?.isActive && <GridToolbar>
                <CustomButton title={t('tenantsList.add_new')}
                              onClick={() => setDialogOpen(true)}/>
            </GridToolbar>}
            <GridNoRecords>{t('tabels:no_records_text')}</GridNoRecords>
            <Column field="inventoryItemId" title="ID" editable={false} />
            <Column field="name" title={t('tenantDetails.name')} />
            <Column field="phone" title={t('tenantDetails.phone')} />
            <Column field="email" title={t('tenantDetails.email')} />
            {tenant?.isActive && <Column cell={commandCell} />}
        </Grid>

        <AddDialog
            onClose={onCurrentUserClose}
            currentData={dialogOpen ? {} : undefined}
            onSubmit={HandleUsersDialogSubmit(onUsersDialogSubmit)}
            control={control}
            formState={formState}
            users={users ?? []}
        />
    </>
}

export default Users
